import {
  InboxOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import styles from "./styles.module.scss";
import { routes } from "../../router/mobile/routes";
import i18n from "../../i18n";

export const getTabs = (): ITabObject[] => [
  {
    key: routes.healthOverview.path,
    title: i18n.t("layout.inbox"),
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
];

export const getTabsWeb = (): ITabObject[] => [
  {
    key: routes.healthOverview.path,
    title: i18n.t("layout.inbox"),
    icon: <InboxOutlined className={styles.footerIcon} />,
    topBarExtraIcons: "FilterIcon",
  },
];

export const getPremiumTabs = (): ITabObject[] => [
  // {
  //   key: routes.billing.path,
  //   title: "RT",
  //   icon: <DollarOutlined className={styles.footerIcon} />,
  // },
];

export const getSettingsTabs = (): ISupportTabObject[] => [
  {
    key: routes.settings.path,
    title: i18n.t("layout.settings"),
    icon: <SettingOutlined className={styles.footerIcon} />,
  },
  {
    key: "help-docs",
    title: i18n.t("layout.help"),
    icon: <QuestionCircleOutlined className={styles.footerIcon} />,
  },
];

// V3 Patient App custom icons
const V3OverviewIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 20"
    fill="none"
    className={styles.footerIcon}
  >
    <path
      d="M0.75 10.034L9.7045 1.07951C10.1438 0.640165 10.8562 0.640165 11.2955 1.0795L20.25 10.034M3 7.78401V17.909C3 18.5303 3.50368 19.034 4.125 19.034H8.25V14.159C8.25 13.5377 8.75368 13.034 9.375 13.034H11.625C12.2463 13.034 12.75 13.5377 12.75 14.159V19.034H16.875C17.4963 19.034 18 18.5303 18 17.909V7.78401M6.75 19.034H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// const V3CareIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 18 21"
//     fill="none"
//     className={styles.footerIcon}
//   >
//     <path
//       d="M8.34952 2.33619C8.28483 2.54602 8.25 2.76894 8.25 3C8.25 3.41421 8.58579 3.75 9 3.75H13.5C13.9142 3.75 14.25 3.41421 14.25 3C14.25 2.76894 14.2152 2.54602 14.1505 2.33619M8.34952 2.33619C8.63276 1.41757 9.48842 0.75 10.5 0.75H12C13.0116 0.75 13.8672 1.41757 14.1505 2.33619M8.34952 2.33619C7.97386 2.35858 7.59937 2.38529 7.22608 2.41627C6.09499 2.51015 5.25 3.47324 5.25 4.60822V6.75M14.1505 2.33619C14.5261 2.35858 14.9006 2.38529 15.2739 2.41627C16.405 2.51015 17.25 3.47324 17.25 4.60822V15C17.25 16.2426 16.2426 17.25 15 17.25H12.75M5.25 6.75H1.875C1.25368 6.75 0.75 7.25368 0.75 7.875V19.125C0.75 19.7463 1.25368 20.25 1.875 20.25H11.625C12.2463 20.25 12.75 19.7463 12.75 19.125V17.25M5.25 6.75H11.625C12.2463 6.75 12.75 7.25368 12.75 7.875V17.25M4.5 14.25L6 15.75L9 12"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const V3ChatIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     className={styles.footerIcon}
//   >
//     <path
//       d="M7.5 8.25H16.5M7.5 11.25H12M2.25 12.7593C2.25 14.3604 3.37341 15.754 4.95746 15.987C6.08596 16.1529 7.22724 16.2796 8.37985 16.3655C8.73004 16.3916 9.05017 16.5753 9.24496 16.8674L12 21L14.755 16.8675C14.9498 16.5753 15.2699 16.3917 15.6201 16.3656C16.7727 16.2796 17.914 16.153 19.0425 15.9871C20.6266 15.7542 21.75 14.3606 21.75 12.7595V6.74056C21.75 5.13946 20.6266 3.74583 19.0425 3.51293C16.744 3.17501 14.3926 3 12.0003 3C9.60776 3 7.25612 3.17504 4.95747 3.51302C3.37342 3.74593 2.25 5.13956 2.25 6.74064V12.7593Z"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

const V3RemindersIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={styles.footerIcon}
  >
    <path
      d="M12 6V12H16.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProfileIcon = () => (
  <svg width="22" height="22" viewBox="0 0 18 18" fill="none">
    <path
      d="M14.4831 15.1644C13.2278 13.5077 11.2389 12.4375 9 12.4375C6.76114 12.4375 4.77223 13.5077 3.51692 15.1644M14.4831 15.1644C16.1807 13.6533 17.25 11.4515 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 11.4515 1.81929 13.6533 3.51692 15.1644M14.4831 15.1644C13.0255 16.4618 11.1048 17.25 9 17.25C6.89518 17.25 4.97446 16.4618 3.51692 15.1644M11.75 6.9375C11.75 8.45628 10.5188 9.6875 9 9.6875C7.48122 9.6875 6.25 8.45628 6.25 6.9375C6.25 5.41872 7.48122 4.1875 9 4.1875C10.5188 4.1875 11.75 5.41872 11.75 6.9375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Health App tabs — built via function so translations update on language change
export const getHealthAppTabs = (): ITabObject[] => [
  {
    key: routes.healthOverview.path,
    title: i18n.t("layout.overview"),
    icon: <V3OverviewIcon />,
  },
  // {
  //   key: routes.healthCare.path,
  //   title: i18n.t("layout.care"),
  //   icon: <V3CareIcon />,
  // },
  // {
  //   key: routes.healthChat.path,
  //   title: i18n.t("layout.chat"),
  //   icon: <V3ChatIcon />,
  // },
  {
    key: routes.healthReminders.path,
    title: i18n.t("layout.reminders"),
    icon: <V3RemindersIcon />,
  },
  {
    key: routes.patientProfileSharing.path,
    title: i18n.t("settings.tab.sharing"),
    icon: <ShareAltOutlined className={styles.footerIcon} />,
  },
  {
    key: routes.patientProfile.path,
    title: i18n.t("settings.tab.userProfile"),
    icon: <ProfileIcon />,
  },
];

/** @deprecated Use getHealthAppTabs() for live translations */
export const healthAppTabs = getHealthAppTabs();

/** @deprecated Use getTabs() for live translations */
export const tabs = getTabs();
/** @deprecated Use getTabsWeb() for live translations */
export const tabsWeb = getTabsWeb();
/** @deprecated Use getPremiumTabs() for live translations */
export const premiumTabs = getPremiumTabs();
/** @deprecated Use getSettingsTabs() for live translations */
export const settingsTabs = getSettingsTabs();
